import { FormControl, ValidationErrors, ValidatorFn } from '@angular/forms'

export const formGroupControlsValidator =
    (controls: FormControl[]): ValidatorFn =>
    (): ValidationErrors | null =>
        controls.some((control) => control.errors !== null || control.invalid)
            ? { formGroupInvalid: true }
            : null
